
export const KIDS_SHIRT_SIZES = [
    116, 134, 146, 152
]